"use strict";

var _defineProperty = require("/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/defineProperty.js");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.table = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var table_module_css_1 = __importDefault(require("./table.module.css"));
function table(props) {
  var headCells = props.children[0].props.children[0].props.children;
  var headings = headCells.map(function (item) {
    return item.props.children[0] && item.props.children[0] !== '' ? item.props.children[0].props.children : '';
  });
  var body = props.children[1].props.children;
  return react_1.default.createElement("table", {
    className: classnames_1.default(table_module_css_1.default.table, _defineProperty({}, table_module_css_1.default.extendedTable, headings.length > 1))
  }, react_1.default.createElement("thead", null, react_1.default.createElement("tr", null, headCells)), react_1.default.createElement("tbody", null, body.map(function (row, i) {
    return react_1.default.createElement("tr", {
      key: i + '_row'
    }, row.props.children.map(function (cell, j) {
      return react_1.default.createElement("td", {
        key: j + '_cell'
      }, react_1.default.createElement("div", {
        "data-head": headings[j]
      }, cell.props.children));
    }));
  })));
}
exports.table = table;